import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const LoginLogForm = ({ users, selectedUser, onUserChange, onSubmit }) => {
  const [localUser, setLocalUser] = useState(selectedUser || '');
  const [error, setError] = useState('');

  useEffect(() => {
    setLocalUser(selectedUser || '');
    setError('');
  }, [selectedUser]);

  const handleChange = (e) => {
    setLocalUser(e.target.value);
    setError('');
    onUserChange(e.target.value);
  };

  const handleClear = () => {
    setLocalUser('');
    setError('');
    onUserChange('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!localUser) {
      setError('Please select a user.');
      return;
    }
    setError('');
    onSubmit();
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400, width: '100%', mx: 'auto', mt: 1, p: 0 }} autoComplete="off">
      <Box sx={{ fontWeight: 700, fontSize: 18, color: '#111', mb: 2.5, letterSpacing: 0.7, textAlign: 'left', width: '100%' }}>
        Login Log
      </Box>
      <Stack spacing={2} alignItems="center">
        <FormControl fullWidth error={!!error} size="small">
          {/* Autocomplete for user: search by username */}
          <Autocomplete
            id="user_id"
            options={users}
            getOptionLabel={(option) => option.username ? option.username.charAt(0).toUpperCase() + option.username.slice(1) : ''}
            value={users.find(u => u.user_id === localUser) || null}
            onChange={(event, newValue) => {
              setLocalUser(newValue ? newValue.user_id : '');
              setError('');
              onUserChange(newValue ? newValue.user_id : '');
            }}
            isOptionEqualToValue={(option, value) => option.user_id === value.user_id}
            renderInput={(params) => (
              <TextField
                {...params}
                label="User"
                error={!!error}
                helperText={error}
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    minHeight: 45,
                    height: 45,
                    color: '#111',
                    '& fieldset': { borderColor: !!error ? '#D32F2F' : '#BDBDBD' },
                    '&:hover fieldset': { borderColor: !!error ? '#D32F2F' : '#BDBDBD' },
                    '&.Mui-focused fieldset': { borderColor: !!error ? '#D32F2F' : '#00C853' },
                  },
                  '& label.Mui-focused': { color: '#00C853' },
                }}
                inputProps={{ ...params.inputProps, maxLength: 50 }}
              />
            )}
            filterOptions={(options, { inputValue }) =>
              options.filter(option =>
                option.username &&
                option.username.toLowerCase().includes(inputValue.toLowerCase())
              )
            }
            clearOnEscape
          />
        </FormControl>
        <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
          <Button type="submit" fullWidth variant="contained" sx={{ bgcolor: '#00C853', '&:hover': { bgcolor: '#009e46' }, minWidth: 90, height: 40, fontWeight: 700, fontSize: 16, letterSpacing: 1 }} disabled={!localUser}>
            Show Logs
          </Button>
          <Button type="button" fullWidth variant="outlined" sx={{ color: '#00C853', borderColor: '#00C853', minWidth: 90, height: 40, fontWeight: 700, fontSize: 16, letterSpacing: 1, '&:hover, &:active': { borderColor: '#009e46', color: '#009e46' } }} onClick={handleClear}>
            Clear
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default LoginLogForm; 